import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FAIRE_PAY_MULTI_USER_MVP_250813 } from "@faire/web-api--source/indigofair/settings/FAIRE_PAY_MULTI_USER_MVP_250813";

export const useSettingFairePayMultiUserMvp = (): boolean => {
  return useSetting(FAIRE_PAY_MULTI_USER_MVP_250813, false);
};
